import {
  LyraLibraryResource,
  ResourceContentFormat,
} from '@lyrahealth-inc/shared-app-logic/src/models/messages/Messages'

import { baseApi, RTKQueryTag } from '../../../data/baseApi'

export enum LyraAISummaryPromptType {
  UNSPECIFIED = 0,
  V1 = 1,
}

enum LyraAISummaryStatus {
  NOT_STARTED = 'NOT_STARTED',
  IN_PROGRESS = 'IN_PROGRESS',
  COMPLETE = 'COMPLETE',
  NOT_FOUND = 'NOT_FOUND',
  ERROR = 'ERROR',
}

type GetLyraAISummariesArgs = {
  providerIds?: string[]
  conversationIds?: string[]
  startTimestamp?: string
  endTimestamp?: string
  promptType?: LyraAISummaryPromptType
  excludeSummary?: boolean
}

export type LyraAISummaryResource = Pick<LyraLibraryResource, 'title' | 'metadata'> &
  Partial<Pick<LyraLibraryResource, 'content_id'>> & {
    content_format?: ResourceContentFormat | keyof typeof ResourceContentFormat
  }

export type LyraAISummary = {
  conversation_id: {
    value: string
  }
  provider_id: {
    value: string
  }
  start_message_timestamp: string
  end_message_timestamp?: string
  summary: {
    summary_text: string
    prompt_type: string
    start_message_id: string
    end_message_id?: string
    status: LyraAISummaryStatus
    // Resources from the full summary window, independent of loaded chat history.
    lyra_library_resources?: LyraAISummaryResource[]
  }
}

const lyraAISummariesApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getLyraAISummaries: builder.query<LyraAISummary[], GetLyraAISummariesArgs>({
      query: ({ providerIds, conversationIds, startTimestamp, endTimestamp, promptType, excludeSummary }) => ({
        method: 'post',
        url: '/v1/provider-summaries',
        data: {
          provider_ids: providerIds,
          conversation_ids: conversationIds,
          start_timestamp: startTimestamp,
          end_timestamp: endTimestamp,
          prompt_type: promptType,
          exclude_summary: excludeSummary,
        },
      }),
      providesTags: [RTKQueryTag.LYRA_AI_SUMMARY],
    }),
  }),
})

export const { useGetLyraAISummariesQuery } = lyraAISummariesApi
export default lyraAISummariesApi
